import { Component, Injector, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';

import { BaseFormComponent } from '../base-form.component';

import { AmorphicService } from '../../../../services/amorphic/amorphic.service';

@Component({
  moduleId: module.id,
  selector: 'missing',
  templateUrl: './missing.component.html',
})
export class MissingComponent extends BaseFormComponent {
  @Input() inputQuestionItem;

  constructor(protected injector: Injector, private amorphicService: AmorphicService) {
    super(injector);
    try {
      this.questionItem = this.injector.get('questionItem');
    } catch (error) {
      this.questionItem = this.inputQuestionItem;
    }

    this.setVisibility();
  }

  resetValue() {}

  updateFromModel() {}
}
